import dynamic from 'next/dynamic';

import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });

const Modal = ({
  activeModal,
  onClose = () => {},
  noFade,
  disableBackdrop,
  className = "max-w-xl",
  children,
  footerContent,
  centered,
  scrollContent,
  themeClass = "bg-zinc-700 dark:bg-metaxseed-dark-gray dark:border-b-2 dark:border-zinc-700",
  footerClass,
  title = "Basic Modal",
  uncontrol,
  label = "Basic Modal",
  labelClass,
  titleClass,
  bodyClass,
  fireworks = false,
  ref,
}) => {
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(!showModal);
  };
  const returnNull = () => {
    return null;
  };

  return (
    <>
      {uncontrol ? (
        <>
          <button
            type="button"
            onClick={openModal}

            data-testid="modal-trigger"
            className={`btn ${labelClass}`}
          >
            {label}
          </button>
          <Transition appear show={showModal} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-[99999]"

            data-testid="modal-dialog"
              onClose={!disableBackdrop ? closeModal : returnNull}
            >
              {!disableBackdrop && (
                <Transition.Child
                  as={Fragment}
                  enter={noFade ? "" : "duration-300 ease-out"}
                  enterFrom={noFade ? "" : "opacity-0"}
                  enterTo={noFade ? "" : "opacity-100"}
                  leave={noFade ? "" : "duration-200 ease-in"}
                  leaveFrom={noFade ? "" : "opacity-100"}
                  leaveTo={noFade ? "" : "opacity-0"}
                >
                  <div className="fixed inset-0 bg-metaxseed-black/50 backdrop-filter backdrop-blur-sm" data-testid="modal-backdrop" />
                </Transition.Child>
              )}

            <div className={"fixed inset-0" + (!fireworks ? ' overflow-y-auto' : '')}>
                {fireworks && (
            <div className="fireworksWrapper" data-testid="fireworks-wrapper">
            <div className="before"></div>
            <div className="after"></div>
        </div>
                )}
                <div
                  className={`flex min-h-full justify-center text-center p-6 ${
                    centered ? "items-center" : "items-start "
                  }`}
                >
                  <Transition.Child
                    as={Fragment}
                    enter={noFade ? "" : "duration-300  ease-out"}
                    enterFrom={noFade ? "" : "opacity-0 scale-95"}
                    enterTo={noFade ? "" : "opacity-100 scale-100"}
                    leave={noFade ? "" : "duration-200 ease-in"}
                    leaveFrom={noFade ? "" : "opacity-100 scale-100"}
                    leaveTo={noFade ? "" : "opacity-0 scale-95"}
                  >
                    <Dialog.Panel
                      className={`w-full dialog-panel transform overflow-hidden rounded-md
                    bg-metaxseed-dark-gray text-metaxseed-text-gray text-left align-middle shadow-xl transition-all ${className}`}
                    >
                      <div
                        className={`relative overflow-hidden  outline-none py-4 px-5 text-white flex justify-between  ${themeClass}`}
                      >
                        <h2 className={`capitalize leading-6 tracking-wider gothamMedium font-normal text-base text-white  ${titleClass}`}>
                          {title}
                        </h2>
                        <button 
                        data-testid="modal-close-button"
                        onClick={closeModal} className="text-[22px] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none !shadow-none">
                          <Icon icon="heroicons-outline:x" />
                        </button>
                      </div>
                      <div
                        className={`px-6 py-8 ${bodyClass} ${
                          scrollContent ? "overflow-y-auto max-h-[400px]" : ""
                        }`}
                      >
                        {children}
                      </div>
                      {footerContent && (
                        <div data-testid="footer-content" className={`px-4 py-3 flex justify-end space-x-3 border-t border-slate-100 dark:border-slate-700   ${footerClass}`}>
                          {footerContent}
                        </div>
                      )}
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </>
      ) : (
        <Transition appear show={activeModal} as={Fragment}>
          <Dialog as="div" className="relative z-[99999]" 
          
          data-testid="modal-dialog"
          onClose={onClose}>
          {!disableBackdrop && (
                <Transition.Child
                  as={Fragment}
                  enter={noFade ? "" : "duration-300 ease-out"}
                  enterFrom={noFade ? "" : "opacity-0"}
                  enterTo={noFade ? "" : "opacity-100"}
                  leave={noFade ? "" : "duration-200 ease-in"}
                  leaveFrom={noFade ? "" : "opacity-100"}
                  leaveTo={noFade ? "" : "opacity-0"}
                >
                  <div className="fixed inset-0 bg-metaxseed-black/50 backdrop-filter backdrop-blur-sm" data-testid="modal-backdrop" />
                </Transition.Child>
              )}

            <div className={"fixed inset-0" + (!fireworks ? ' overflow-y-auto' : '')}>
            {fireworks && (
            <div className="fireworksWrapper" data-testid="fireworks-wrapper">
            <div className="before"></div>
            <div className="after"></div>
        </div>
                )}
              <div
                className={`flex min-h-full justify-center text-center p-6 ${
                  centered ? "items-center" : "items-start "
                }`}
              >
                <Transition.Child
                  as={Fragment}
                  enter={noFade ? "" : "duration-300  ease-out"}
                  enterFrom={noFade ? "" : "opacity-0 scale-95"}
                  enterTo={noFade ? "" : "opacity-100 scale-100"}
                  leave={noFade ? "" : "duration-200 ease-in"}
                  leaveFrom={noFade ? "" : "opacity-100 scale-100"}
                  leaveTo={noFade ? "" : "opacity-0 scale-95"}
                >
                  <Dialog.Panel
                    className={`w-full dialog-panel transform overflow-hidden rounded-md
                    bg-metaxseed-dark-gray text-metaxseed-text-gray text-left align-middle shadow-xl transition-all ${className}`}
                  >
                    <div
                        className={`relative overflow-hidden  outline-none py-4 px-5 text-white flex justify-between  ${themeClass}`}
                    >
                      <h2 className={`capitalize leading-6 tracking-wider gothamMedium font-normal text-base text-white  ${titleClass}`}>
                        {title}
                      </h2>
                      <button 
                      data-testid="modal-close-button"
                      onClick={onClose} className="text-[22px] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none !shadow-none">
                        <Icon icon="heroicons-outline:x" />
                      </button>
                    </div>
                    <div
                      className={`px-6 py-8 ${bodyClass} ${
                        scrollContent ? "overflow-y-auto max-h-[400px]" : ""
                      }`}
                    >
                      {children}
                    </div>
                    {footerContent && (
                      <div data-testid="footer-content" className={`px-4 py-3 flex justify-end space-x-3 border-t border-slate-100 dark:border-slate-700   ${footerClass}`}>
                        {footerContent}
                      </div>
                    )}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}
    </>
  );
};

export default Modal;
